import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';
import commonFn from '@/commons/commonFunction';

class BUOpeningCommitmentAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUOpeningCommitments';
  /**
   * Get dữ liệu danh sách cột công thức
   * @returns
   * NNLINH 01.07.2022
   */
  async getListCommitmentByRefId(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/listCommitment',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Override hàm get combobox CKC
   * @param {*} payload
   * @returns
   * NNLINH 03.08.2022
   */
  getComboboxPaging(payload) {
    let param = { ...payload };

    //xử lý tham số trước khi request load dữ liệu
    commonFn.processComboboxParamRequest(param);

    let request = {
      url: this.getAPIUrl() + '/comboboxCommitment',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new BUOpeningCommitmentAPI();
